"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function () {
  let defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const [state, setState] = _react.default.useState(defaultState);
  const open = _react.default.useCallback(() => {
    setState(true);
  }, [state]);
  const close = _react.default.useCallback(() => {
    setState(false);
  }, [state]);
  const toggle = _react.default.useCallback(() => {
    setState(!state);
  }, [state]);
  return {
    state,
    toggle,
    open,
    close
  };
};
exports.default = _default;